import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IRemoteAgentService = ( createDecorator('remoteAgentService'));
export { IRemoteAgentService };
